import React from 'react';
import styled from 'react-emotion';
import PropTypes from 'prop-types';

const Title = styled.div`
  line-height: 40px;
  font-size: 24px;
`;

const CoachName = ({ children }) => <Title>{children}</Title>;

CoachName.propTypes = {
  children: PropTypes.arrayOf(PropTypes.string)
};

CoachName.defaultProps = {
  children: null
};

export default CoachName;



// WEBPACK FOOTER //
// ./src/components/CoachInfos/CoachName.jsx